import { Box, type BoxProps } from '@chakra-ui/react'
import { Ellipsis } from 'BrokerTsLib/src/components'

interface InsuranceValueProps {
  value: string | React.ReactNode
  tooltip?: React.ReactNode
}

export const InsuranceValue = ({ value, tooltip, ...rest }: InsuranceValueProps & BoxProps) => {
  return (
    <Box layerStyle="insuranceValue" {...rest}>
      <Ellipsis
        as={Box}
        tooltipProps={{
          trigger: 'clickHover',
          maxW: '500px',
          label: tooltip,
          placement: 'top',
          hasArrow: true,
          closeOnEsc: true,
          isDisabled: false
        }}
        fontSize="md"
        fontWeight="bold"
        children={value}
      />
    </Box>
  )
}
